// extracted by css-extract-rspack-plugin
export default {"root":"Kbd-module__root___kdxiR"};